import { useState } from 'react'
import { ReadingChat } from '@lunary/ui-web/reading-chat'
import { sourceLabel } from '../users/labels'
import { ContextPane } from './context-pane'
import { ExpertComposer } from './expert-composer'
import { useAdminChat, useReactToMessage } from './queries'
import styles from './readings.module.css'

export function ChatPane({ id, onBack }: { id: string; onBack: () => void }) {
  const [info, setInfo] = useState(false)
  const chat = useAdminChat(id)
  const react = useReactToMessage(id)

  if (chat.isPending) return <div className="spinner" aria-label="Загрузка" />
  if (chat.isError) return <p className="error-box">Не удалось открыть переписку.</p>

  const { reading, messages, history, voice_enabled: voiceEnabled } = chat.data
  const arcana = reading.personal_arcana
  const topic = `${reading.format === 'consultation' ? 'Консультация · ' : ''}${reading.topic_titles.length > 0 ? reading.topic_titles.join(', ') : reading.topic_title}`
  const person = reading.person
  const subtitle = [arcana ? `${arcana.arcana.name} · ${arcana.zodiac_name}` : null, sourceLabel(reading.source)].filter(Boolean).join(' · ')

  return (
    <div className={styles.chatWrap}>
      <div className={styles.chatMain}>
      <div className={styles.chatBar}>
        <button type="button" className={styles.backBtn} onClick={onBack} aria-label="Назад к списку">
          ← К списку
        </button>
        <button type="button" className={styles.infoBtn} aria-pressed={info} onClick={() => setInfo((v) => !v)}>
          О человеке
        </button>
      </div>
      <div className={styles.chatInfo} data-open={info ? 'true' : undefined}>
        <ContextPane reading={reading} history={history} />
      </div>
      <section className={styles.chatBox} aria-label={`Разбор: ${topic}`}>
        <ReadingChat
          reading={reading}
          messages={messages}
          viewer="expert"
          person={{ name: person?.display_name ?? null, avatarUrl: person?.avatar_url ?? null }}
          topicLabel={topic}
          title={topic}
          subtitle={subtitle}
          onReact={(messageId, reaction) => react.mutate({ messageId, reaction })}
          composer={<ExpertComposer reading={reading} voiceEnabled={voiceEnabled} />}
        />
      </section>
      </div>
      <div className={styles.sideCol}>
        <ContextPane reading={reading} history={history} />
      </div>
    </div>
  )
}
